import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from './http.js';
import './iview.js';
import baseMethod from './global/baseMethod.js';
// import download from "./global/downLoadFiles";
Vue.prototype.$axios = axios;
Vue.use(baseMethod);
const on = Vue.prototype.$on
    // 节流
Vue.prototype.$on = function(event, func) {
    let previous = 0
    let newFunc = func
    if (event === 'click') {
        newFunc = function() {
            const now = new Date().getTime()
            if (previous + 1000 <= now) {
                func.apply(this, arguments)
                previous = now
            }
        }
    }
    on.call(this, event, newFunc)
}

Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')